import React from 'react';
import PropTypes from 'prop-types';

import css from './Button.css';

const Button = ({ children, onClick, type, className, styles }) => {
  const renderClassName = () => {
    if (!className) {
      return css.Button;
    } else if (className && typeof className === 'string') {
      return [css.Button, css[className]].join(' ');
    }

    const classArray = className.map(c => css[c]);
    return [css.Button, ...classArray.map(c => css[c])].join(' ');
  };

  return (
    <button
      className={renderClassName()}
      style={{
        ...styles,
        background: styles.background ? styles.background : 'none'
      }}
      type={type}
      onClick={onClick}
    >
      {children}
    </button>
  );
};

Button.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.node
  ]),
  onClick: PropTypes.func,
  type: PropTypes.string,
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string)
  ]),
  styles: PropTypes.shape()
};

Button.defaultProps = {
  children: undefined,
  onClick: () => undefined,
  type: 'button',
  className: '',
  styles: {}
};

export { Button };



// WEBPACK FOOTER //
// ./src/components/common/Button/Button.js